import React from "react";
import PropTypes from "prop-types";
import { FaSort, FaSortAmountUpAlt, FaSortAmountDown } from "react-icons/fa";
import { ASC, DESC } from "../../utils/constants/appConstants";

const SortableHeaderCell = ({
  column,
  isSortable,
  columnOrders,
  handleSort,
  tableSortWithIcon = false,
  isLastColumn = false
}) => {
  const getSortIcon = (showDefault = false) => {
    const order = columnOrders?.[column.id];

    if (order === ASC) return <FaSortAmountUpAlt />;
    if (order === DESC) return <FaSortAmountDown />;

    return showDefault ? <FaSort /> : null;
  };

  const thProps = {
    onClick: isSortable ? () => handleSort(column.id) : undefined,
    className: isSortable ? "cursor-pointer" : ""
  };

  if (tableSortWithIcon) {
    return (
      <th {...thProps}>
        {isLastColumn || !isSortable ? (
          <span>{column.render("Header")}</span>
        ) : (
          <>
            <span>{column.render("Header")}</span>
            <span className="short-icon">{getSortIcon(true)}</span>
          </>
        )}
      </th>
    );
  }

  return (
    <th {...thProps}>
      {isSortable && <span className="me-1">{getSortIcon()}</span>}
      <span>{column.render("Header")}</span>
    </th>
  );
};

SortableHeaderCell.propTypes = {
  column: PropTypes.any,
  isSortable: PropTypes.bool,
  columnOrders: PropTypes.objectOf(PropTypes.oneOf([ASC, DESC, null]))
    .isRequired,
  handleSort: PropTypes.func.isRequired,
  tableSortWithIcon: PropTypes.bool,
  isLastColumn: PropTypes.bool
};

export default SortableHeaderCell;
